import templateUrl from "./mobile-app-links.component.html";
import "./mobile-app-links.component.less";

export const MobileAppLinksComponent = {
    templateUrl
}
